var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('quill-editor',{ref:"myTextEditor",attrs:{"options":_vm.quillOption},model:{value:(_vm.contents),callback:function ($$v) {_vm.contents=$$v},expression:"contents"}}),_c('el-button',{staticClass:"submit",attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("提交")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }